/* eslint-disable */
import React, { useState, useEffect } from 'react';
import { Text, Button, Flex, toast } from '@chatui/core';
import { Form, ConfigProvider } from "antd";
import HeadeNavbar from '../components/headeNavbar'
import AntdFormContent from '../components/template/antdFormContent'
import CreateTicketFormFields from '../components/template/createTicketFormFields'
import { getTemplate, createTicket } from '../services/ticket';
import { searchObj } from '../utils/util';
import { entity } from '../utils/entity';
import moment from 'moment';
import { parse, stringify } from 'lossless-json';
import 'moment/locale/zh-cn';
import zhCN from 'antd/lib/locale/zh_CN';
moment.locale('zh-cn');
// window.less.modifyVars({ '@primary-color': '#ffe092' })

const WorkOrderSubmit = props => {
  const [form] = Form.useForm();
  const [template, setTemplate] = useState({});
  const search = searchObj(props.location.search);

  useEffect(() => {
    if (search && search.game_id && search.account) {
      if (!props.location?.query?.tplId) {
        props.history.push({ pathname: '/workOrderList', search: props.location.search })
      } else {
        getTemplate({ tplId: props.location.query.tplId })
          .then(res => {
            if (res.code === 0 && res.data.code === 0) {
              setTemplate(res.data.data)
            }
          })
      }
    } else {
      window.location.replace(`${window.location.origin}/closeWin`)
    }
  }, []);

  let fieldsList = [];
  try {
    if (template.fields) {
      fieldsList = parse(template.fields)
    }
  } catch (err) {
  }

  const submit = () => {
    form
      .validateFields()
      .then((values) => {
        let expand = {}
        if (search.expand) {
          try {
            expand = parse(decodeURIComponent(search.expand));
          } catch (err) {
          }
        }
        const ticketForm = CreateTicketFormFields(fieldsList, values)
        let createTicketForm = {
          "entity_id": Number(search.entity_id) || entity.id, // 主体
          "account": search.account, // 内部账号
          "username": '', // 外部账号 $.cookie('uuzu_external_account')
          "level": Number(template.level),
          "game_id": Number(template.game_id),
          "classify": Number(template.classify),
          "cat_id": Number(template.cat_id),// 工单分类ID
          "tpl_id": Number(template.id), // 工单模版ID
          "fields": stringify(
            ticketForm.concat([{
              content: stringify({
                "operator_id": search.op_id,
                "operator_name": "",
                "server_id": expand.serverID || "",
                "server_name": expand.serverName || "",
                "role_id": expand.roleID || "",
                "role_name": expand.roleName || ""
              }),
              content_value: expand.roleName || "",
              field_name: "角色名称",
              field_order: 0,
              field_uid: fieldsList.length,
              required: false,
              type: 26
            }]),
          ),
          "extendsValid": { // 新增字段用于提交表单校验（内容包含：身份证名称，身份证号，手机号，手机验证码，图形验证码，后台发现为空则不校验）
            "IDENTITY_NAME": "",//身份证名称  ticketForm
            "IDENTITY_CARD": "",//身份证号
            "PHONE_NUMBER": "",//手机号
            "PHONE_CODE": "",//手机验证码
            "GRAPHIC_CODE": "",//图形验证码
          }
        }
        if (ticketForm.find(i => i.type === 20)) {
          const icJson = parse(ticketForm.find(i => i.type === 20).content);
          createTicketForm.extendsValid.IDENTITY_NAME = icJson.name;
          createTicketForm.extendsValid.IDENTITY_CARD = icJson.ic;
        }
        if (ticketForm.find(i => i.type === 30)) {
          const phoneJson = parse(ticketForm.find(i => i.type === 30).content);
          createTicketForm.extendsValid.PHONE_NUMBER = phoneJson.phone;
          createTicketForm.extendsValid.PHONE_CODE = phoneJson.code;
        }
        createTicket(createTicketForm)
          .then(res => {
            if (res.data.code === 0) {
              form.resetFields();
              toast.success('提交成功')
              props.history.push({ pathname: '/myWorkOrder', search: props.location.search })
              //跳转
            } else if (res.data.code === 2001) {
              toast.fail('同一个问题的事件未结束，不可再次提交事件')
            } else {
              toast.show(res.data.message || res.msg)
            }
          })
      })
  }

  return (
    <HeadeNavbar title={"提交问题"}>
      <ConfigProvider locale={zhCN}>
        <div style={{ padding: '1em 2em' }}>
          <Text>{template.desc}</Text><br />
          <Form
            layout='vertical'
            form={form}
          >
            {fieldsList.map((item, index) => {
              return AntdFormContent(item, index, form)
            })}
          </Form>
          <Flex >
            <p style={{ color: "var(--brand-1)" }}>提示：同一个问题的事件未结束，不可再次提交事件。</p>
          </Flex>
          <Flex center style={{ paddingTop: "20px" }}>
            <Button color="primary" style={{ maxWidth: '400px', width: '100%' }} onClick={submit}>提交</Button>
          </Flex>
        </div>
      </ConfigProvider>
    </HeadeNavbar >
  );
};

export default WorkOrderSubmit;
